import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EstaticoService } from '../../services/estatico.service';
import { Location } from '@angular/common';
import {AppConfig} from '../../AppConfig';

@Component({
    selector: 'app-estatico-generico',
    templateUrl: './estatico-generico.component.html',
    styleUrls: ['./estatico-generico.component.css'],
    standalone: false
})
export class EstaticoGenericoComponent implements OnInit, AfterViewInit {

  @ViewChild('iframeElem') iframe!: ElementRef;

  tamano:string = "";
  html: string;
  nombre: string;
  lista: string[] = ['consejos.html', 'directorio.html', 'mas.html', 'quienes.html'];
  listo:boolean = false;


  constructor( private activateRoute: ActivatedRoute, private estaticoServ: EstaticoService,
    private location: Location, private config: AppConfig) {
      if (this.listo){
        this.listo = false;
      }
  }

  ngOnInit() {
    this.activateRoute.paramMap.subscribe( params => {
      let nombre = params.get('pagina');

      console.log("nombre contenido estatico " + nombre);
      if(this.lista.indexOf(nombre) >= 0) {
        this.html = `${this.config.getConfig('base_url_estaticos')}/tmp/${nombre}`;
        this.listo = true;
      } else {
        this.html = `${this.config.getConfig('iplanet')}${this.config.getConfig('endpoint.paths.estaticos')}${nombre}`;
        this.listo = true;
      }
      
    });
  }

  ngAfterViewInit() {
    // Agregar listener para ajustar altura del iframe dinámicamente
    this.setupIframeResizing();
  }

  setupIframeResizing() {
    if (this.iframe && this.iframe.nativeElement) {
      const iframeElement = this.iframe.nativeElement;
      
      // Escuchar cuando el iframe se carga
      iframeElement.addEventListener('load', () => {
        this.adjustIframeHeight();
        
        // Para contenido que se expande dinámicamente (como acordeones)
        if (this.html.includes("proceso") || this.html.includes("Frecuentes")) {
          // Observar cambios en el contenido del iframe
          this.observeIframeContent();
        }
      });
    }
  }

  adjustIframeHeight() {
    try {
      const iframeElement = this.iframe.nativeElement;
      const iframeDocument = iframeElement.contentDocument || iframeElement.contentWindow?.document;
      
      if (iframeDocument) {
        // Obtener la altura real del contenido
        const contentHeight = Math.max(
          iframeDocument.body.scrollHeight,
          iframeDocument.body.offsetHeight,
          iframeDocument.documentElement.clientHeight,
          iframeDocument.documentElement.scrollHeight,
          iframeDocument.documentElement.offsetHeight
        );
        
        // Solo aplicar altura automática para proceso y preguntas frecuentes
        if (this.html.includes("proceso") || this.html.includes("Frecuentes")) {
          const minHeight = 600;
          const maxHeight = 1200;
          const newHeight = Math.min(Math.max(contentHeight + 20, minHeight), maxHeight);
          
          iframeElement.style.height = newHeight + 'px';
          console.log(`Altura ajustada para ${this.html}: ${newHeight}px`);
        }
      }
    } catch (error) {
      console.log('No se pudo ajustar la altura del iframe debido a restricciones de CORS');
    }
  }

  observeIframeContent() {
    try {
      const iframeElement = this.iframe.nativeElement;
      const iframeDocument = iframeElement.contentDocument || iframeElement.contentWindow?.document;
      
      if (iframeDocument && window.MutationObserver) {
        const observer = new MutationObserver(() => {
          // Pequeño delay para permitir que las animaciones terminen
          setTimeout(() => {
            this.adjustIframeHeight();
          }, 300);
        });
        
        observer.observe(iframeDocument.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
        
        console.log('Observer configurado para contenido dinámico');
      }
    } catch (error) {
      console.log('No se pudo configurar el observer debido a restricciones de CORS');
    }
  }

  get iframeStyles() {
    console.log("html:", this.html);
 
    if (this.html.includes("proceso") || this.html.includes("Frecuentes")) {
      console.log("includes - estilos dinámicos con altura automática");
      return {
        'width': '100%',
        'min-height': '600px',
        'height': 'auto',
        'max-height': '1200px',
        'border': '0',
        'overflow': 'auto'
      };
    } else if(this.html.includes("forma")){
      console.log("default - forma de pago");
      return {
        'width': '100%',
        'min-height': '250px',
        'height': 'auto',
        'border': '0'
      };
    } else if(this.html.includes("quienes")){
      console.log("quienes somos - estilos más pequeños");
      return {
        'width': '100%',
        'height': '450px',
        'border': '0'
      };
    } else if(this.html.includes("sitios")) {
      console.log("default - estilos pequeños");
      return {
        'width': '100%',
        'height': '750px',
        'border': '0'
      };
    } else {
      console.log("default - estilos estándar");
      return {
        'width': '100%',
        'height': '750px',
        'border': '0'
      };
    }
  }

  

}
